import menuItems from '../json/sidebar-menu.json';

export function generateMenuItem() {
    return menuItems.map(item => {
        switch (item.type) {
            case 'label':
                return `<li class="menu-label mt-2"><span>${item.title}</span></li>`;

            case 'link':
                return `
                    <li class="nav-item">
                        <a class="nav-link" href="${item.path}" data-link>
                            <i class="${item.icon} menu-icon"></i>
                            <span>${item.title}</span>
                        </a>
                    </li>`;

            case 'submenu':
                const childrenHtml = item.children.map(child => `
                    <li class="nav-item">
                        <a class="nav-link" href="${child.path}" data-link>${child.title}</a>
                    </li>
                `).join('');

                return `
                    <li class="nav-item">
                        <a class="nav-link" href="#${item.id}" data-bs-toggle="collapse" role="button" aria-expanded="false" aria-controls="${item.id}">
                            <i class="${item.icon} menu-icon"></i>
                            <span>${item.title}</span>
                        </a>
                        <div class="collapse" id="${item.id}">
                            <ul class="nav flex-column">${childrenHtml}</ul>
                        </div>
                    </li>`;
            default:
                return '';
        }
    }).join('');
}
